// extracted by mini-css-extract-plugin
export default {"createSoundtrackContainer":"styles_createSoundtrackContainer__TXEx4"};